// Lib
import gql from 'graphql-tag';

// Types
import { CAMPAIGN_AUTH_TASK_LINK } from '../types';

export const campaignAuthTaskBySecretLight = gql`
  query CampaignAuthTaskBySecret($secret: String!) {
    campaignAuthTaskBySecret(secret: $secret) {
      _id
      createdAt
      updatedAt
      authId
      campaignId
      postCount
      storyCount
      videoCount
      deadline
      status
      secret
      description
      paymentOptions {
        flatFee
        commission
        gift
        terms
      }
      auth {
        avatar {
          url
        }
        fullName
        username
        source
      }
      campaign {
        name
        avatar {
          url
        }
        budget
      }
      gift {
        id
        status
        note
        lineItems {
          quantity
          title
          variant
        }
      }
    }
  }
`;

export const campaignAuthTaskBySecret = gql`
  query CampaignAuthTaskBySecret($secret: String!) {
    campaignAuthTaskBySecret(secret: $secret) {
      _id
      createdAt
      updatedAt
      authId
      campaignId
      postCount
      storyCount
      videoCount
      deadline
      status
      secret
      description
      paymentOptions {
        flatFee
        commission
        gift
        terms
      }
      auth {
        avatar {
          url
        }
        fullName
        username
        source
      }
      campaign {
        name
        hashtags
        mentions
        keywords
        avatar {
          url
        }
        brandName
        websiteUrl
        description
      }
      links {
        ${CAMPAIGN_AUTH_TASK_LINK}
      }
    }
  }
`;

export const campaignAuthTaskLinkGetByShortUrl = gql`
  query CampaignAuthTaskLinkGetByShortUrl($shortUrl: String) {
    campaignAuthTaskLinkGetByShortUrl(shortUrl: $shortUrl) {
      ${CAMPAIGN_AUTH_TASK_LINK}
    }
  }
`;
